import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const ticketDetailsApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.GET_TICKET_BY_ID,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
